import React, { useEffect, useState } from "react";
import {
    SubmitButton,
    FormGroup,
} from "components/common";
import { Control, actions, Errors } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm } from "hooks";
import { Trans } from "react-i18next";
import Select from "react-select";
import { validationMessage } from "constants/validationMsg";
import { HistoryAndNotes } from "components";

export const Edit = ({ t, url = "end_of_service", model = "local", _payroll, match, updateList, id, allowances, client, }) => {
    
    const { dispatch, setValue, Form, save, loaded, load, getTitle, value } = useForm({
        model,
    });


    async function onSubmit(item) {
        try {
            await save(_payroll, url, item);
            NotificationManager.success(t("Saved successfully"));
            updateList()

        } finally {
            dispatch(actions.setPending(model, false));
        }
    }
    useEffect(
        () => {
            void (async () => {
                const item = await load(_payroll, url, id, {});
                setValue(item);
            })()
        }
        ,
        [id]
    );


    if (!loaded) return null;

    return (

        <Form
            onSubmit={onSubmit}
        >
            <div className="row">
                <div className="col-12">
                    <FormGroup label="Name *" model=".description" >
                        <Control.text
                            model=".name"
                            updateOn="blur"
                            placeholder="Name..."
                        />
                        <Errors
                            className="form-text small text-danger"
                            model=".name"
                            show="touched"
                            messages={{
                                required: t(validationMessage.REQUIRED),
                            }}
                        />
                    </FormGroup>
                </div>
                <div className="col-12">
                    <FormGroup label="Days Base *" model=".days_base" >
                        <Control.text
                            model=".days_base"
                            updateOn="blur"
                            placeholder="30"
                            type="Number"
                        />
                        <Errors
                            className="form-text small text-danger"
                            model=".days_base"
                            show="touched"
                            messages={{
                                required: t(validationMessage.REQUIRED),
                            }}
                        />
                    </FormGroup>
                </div>
                <div className="col-12">
                    <div className="my-3">
                        <span>
                            <Control.checkbox
                                model=".salary_in" 
                                defaultValue={true}
                                /> 
                                <span className="mx-2"><Trans>Include Salary</Trans>*</span>
                        </span>
                    </div>

                </div>
                <div className="col-12">
                    <FormGroup
                        label="Allowances *"
                        model=".allowances"
                        addControlClass={false}>
                        <Control.text 
                            placeholder="Select Allowances..."
                            model=".allowances"
                            component={Select}
                            options={allowances.map((x) => ({ value: x.id, label: x.text }))}
                            multi={true}
                            simpleValue
                            clearable={false}
                            searchable={false}
                        />
                        <Errors
                            className="form-text small text-danger"
                            model=".amount_type"
                            show="touched"
                            messages={{
                                required: t(validationMessage.REQUIRED)
                            }}
                        />
                    </FormGroup>
                </div>
                <div className="col-12">
                    <div className="my-3">
                        <span>
                            <Control.checkbox
                                model=".is_default" /> <span className="mx-1"><Trans>Set as Default</Trans></span>
                        </span>
                    </div>

                </div>
            </div>
            <div className="mt-2 mb-2" style={{ float: "right" }}>
                <SubmitButton>
                    {id === "new" ?
                        <Trans>Add</Trans>
                        :
                        <Trans>Save</Trans>
                    }
                </SubmitButton>
            </div>

            <hr />

            <HistoryAndNotes
                item={value}
                contentType={'endofservice'}
                client={client}
                t={t}
            />
        </Form>
    );
};

export default Edit;
